import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthFirebaseService } from './marketplace/service/auth-firebase.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService  {
  constructor(
    @Inject(PLATFORM_ID) private platform,
    private router: Router,
    private firebaseAuth: AuthFirebaseService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (isPlatformBrowser(this.platform) && this.firebaseAuth.getIsLoggedIn) {
      // logged in so return true
      return true;
    }
    this.router.navigate(['/login'], {
      queryParams: { redirectUrl: state.url }
    });
    return false;
  }
}
